import React from "react";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { Row, Col, Spinner, Card, Label } from "reactstrap";
import { InputText } from "primereact/inputtext";
import EditorContainer from "../../components/EditorContainer";
import ManualVehicleEditor from "../../components/VehicleManualEdit";
import PlateVehicleEditor from "../../components/VehiclePlateEdit";
import { getCustomer } from "../../api/customers";
import { createVehicle, updateVehicle, getVehicle } from "../../api/vehicles";

const schema = () =>
    Yup.object({
        plate: Yup.string().nullable(),
        registeredat: Yup.string().nullable(),
        km: Yup.number().required("km obbligatorio"),
        attributes: Yup.object({
            frame: Yup.string().required("Numero di telaio obbligatorio"),
            type: Yup.string().required("Tipo di veicolo obbligatorio"),
            supplier: Yup.string().required("Tipo di alimentazione obbligatorio"),
            infocarMake: Yup.string().required("Marca obbligatoria"),
            infocarModel: Yup.string(),
            infocarSupplier: Yup.string(),
            preparation: Yup.string(),
            make: Yup.string(),
            model: Yup.string()
        })
    });

const VehicleEditor = ({ activeTenant, fromPlate, onCreated, initCustomer }) => {
    let { id, customer_id } = useParams();
    customer_id = customer_id ? customer_id : initCustomer ? initCustomer._id : undefined;
    const [customer, setCustomer] = React.useState(initCustomer || undefined);

    React.useEffect(() => {
        if (!initCustomer) {
            loadCustomer(customer_id);
        }
    }, [customer_id]);

    const loadCustomer = async csId => {
        if (!csId) return;
        const customerRes = await getCustomer(csId);
        setCustomer(customerRes);
    };

    const onCreate = async entity => {
        const result = await createVehicle({
            ...entity,
            customer_id: customer_id
        });
        if (onCreated) {
            onCreated(result);
            return false;
        }
        return result;
    };

    const onLoad = async id => {
        if (onCreated) return
        const vehicle = await getVehicle(id);
        await loadCustomer(vehicle.customer_id);
        return vehicle;
    };

    const onUpdate = async entity => {
        const result = await updateVehicle({
            ...entity,
            customer_id: customer._id
        });
        return result;
    };

    return (
        <EditorContainer
            key={id ? `${id}-vehicle` : "new-vehicle"}
            canSave={true}
            schema={schema}
            onCreate={onCreate}
            onUpdate={onUpdate}
            onLoad={onLoad}
            asSelector={onCreated ? true : false}
            optionalNav={onCreated ? null : {
                link: `/tenant/customers/${customer ? customer._id : ""}`,
                text: "Clienti"
            }}
            redirRoot={`/tenant/customers/${customer ? customer._id : ""}`}
            title={el => `Veicolo del cliente ${customer ? customer.name : " - "}`}
            children={frmProps => {
                const showPlateSearch =
                    fromPlate ||
                    (frmProps.values.attributes && frmProps.values.attributes.fromPlate);
                return !showPlateSearch ? (
                    <ManualVehicleEditor
                        errors={frmProps.errors || {}}
                        vehicle={frmProps.values || {}}
                        onChange={e => {
                            frmProps.setValues(e.value);
                        }}
                    />
                ) : (
                        <PlateVehicleEditor
                            errors={frmProps.errors || {}}
                            vehicle={frmProps.values || {}}
                            onChange={e => {
                                frmProps.setValues(e.value);
                            }}
                        />
                    );
            }}
            renderDealer={() =>
                customer ? (
                    <React.Fragment>
                        <Card body className="rounded bg-secondary mb-2">
                            <Row>
                                <Col sm="4" xs="12" md="4">
                                    <strong>Cliente: </strong>
                                    <Label className="h5">{customer.name}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="4">
                                    <strong>Telefono: </strong>
                                    <Label className="h5">{customer.attributes.phone}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="4">
                                    <strong>Email: </strong>
                                    <Label className="h5">{customer.email}</Label>
                                </Col>
                            </Row>
                        </Card>
                    </React.Fragment>
                ) : (
                        <Spinner style={{ width: "3rem", height: "3rem" }} type="grow" />
                    )
            }
        />
    );
};
export default VehicleEditor;
